import React from 'react';
import { Image, FrameSvg } from '.';
import { convertShapeColorToHex } from '../../util/helpers';
import './CaptionedPhoto.scss';

const CaptionedPhoto = (props) => {
  const {
    photo,
    photoCaption,
    alwaysShowCaption,
    isSquare,
    isLandscape,
    isPortrait,
    hasFrame,
    frameColour,
  } = props;
  let sizeClass = '';
  if (isSquare) sizeClass = ' is-square';
  if (isLandscape) sizeClass = ' is-landscape';
  if (isPortrait) sizeClass = ' is-portrait';
  const classes = `${sizeClass}${alwaysShowCaption ? ' always-show-caption' : ''}${hasFrame ? ' has-frame' : ''}`;
  const frameColourHex = frameColour ? convertShapeColorToHex(frameColour) : null;
  return (
    <div className={`captioned-photo${classes}`}>
      {hasFrame && <FrameSvg frameHex={frameColourHex} />}
      <Image image={photo} alt={photoCaption} />
      {photoCaption && (
        <div className="photo-caption">
          <div className="container">
            <span>{photoCaption}</span>
            <div className="cleft">
              <svg viewBox="0 0 37 21" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <path
                    d="M13.39.947c3.458 1.14 4.973 2.822 4.543 5.046-.643 3.336-2.995 6.89-6.978 9.315C8.3 16.925 4.815 18.103.5 18.842c9.8 2.463 17.982.87 24.544-4.778C31.605 8.415 35.382 3.894 36.374.5L36.5.04H13.39v.907z"
                    fill="#FFFFF4"
                    fillRule="nonzero"
                  />
                  <path
                    d="M13.374.5c3.469 1.438 4.989 3.269 4.56 5.493-.644 3.336-2.996 6.89-6.979 9.315C8.3 16.925 4.815 18.103.5 18.842c9.8 2.463 17.982.87 24.544-4.778C31.605 8.415 35.382 3.894 36.374.5"
                    stroke="#2A2E24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaptionedPhoto;
